
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { Entity } from '../../../../entities/entity';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';
import { ActivityMergeSchema, ActivityMergeData, AttachmentMergeSchema, AttachmentMergeData } from '../data/activity.merge.data';
import { BasicSiteMergeSchema, BasicSiteMergeData } from '../data/basic.site.merge.data';
import { CompanyMergeSchema, CompanyMergeData } from '../data/company.merge.data';
import { InvoiceAccountMergeSchema, InvoiceAccountMergeData } from '../data/invoice.account.merge.data';
import { InvoiceActivitiesMergeDataSchema, InvoiceActivitiesMergeData, InvoiceAttachmentsMergeDataSchema, InvoiceAttachmentsMergeData } from '../data/invoice.attachments.merge.data';
import { InvoiceMergeSchema, InvoiceMergeData } from '../data/invoice.merge.data';
import { InvoiceMergeDataset } from './invoice.merge.dataset';

@MergeDataset({
    entity: ActivityEntityName.Bill,
    dependsOn: [
        ActivityEntityName.Job,
        ActivityEntityName.WorkOrder,
    ]
})
export class BillMergeDataset {
    // Bill reuses the Invoice schemas (field keys stay invoice.*), but these sources belong to a Bill,
    // so label them 'Bill ...' — the picker groups by source displayName, not entity (WBS-7096).
    @MergeSource({
        schema: InvoiceMergeSchema,
        displayName: 'Bill',
        ignoreFields: ['jobLinesBillable']
    })
    invoice: InvoiceMergeData;

    @MergeSource({
        schema: CompanyMergeSchema,
        displayName: 'Bill Company'
    })
    invoiceCompany: CompanyMergeData;

    @MergeSource({
        schema: InvoiceAccountMergeSchema,
        displayName: 'Bill Account'
    })
    invoiceAccount: InvoiceAccountMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema,
        displayName: 'Bill Account Site'
    })
    invoiceAccountSite: BasicSiteMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema,
        displayName: 'Bill Job Site'
    })
    invoiceJobSite: BasicSiteMergeData;

    @MergeSource({
        schema: ActivityMergeSchema,
        displayName: "Activities (Deprecated)",
        ignoreFields: ['attachments']
    })
    activities: ActivityMergeData[];

    @MergeSource({
        schema: AttachmentMergeSchema,
        displayName: "Media Attachments (Deprecated)",

    })
    mediaAttachments: AttachmentMergeData[];

    @MergeSource({
        schema: AttachmentMergeSchema,
        displayName: "File Attachments (Deprecated)"
    })
    fileAttachments: AttachmentMergeData[];

    @MergeSource({
        schema: InvoiceActivitiesMergeDataSchema,
        displayName: 'Bill Activities',
        ignoreCustomFields: true,
    })
    invoiceActivities: InvoiceActivitiesMergeData;

    @MergeSource({
        schema: InvoiceAttachmentsMergeDataSchema,
        displayName: 'Bill Attachment',
        ignoreCustomFields: true,
    })
    invoiceAttachment: InvoiceAttachmentsMergeData;

    public theme: Entity;
}


